import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { LOGIN_PAGE } from "../../constants/app";
import { useAuth } from "../../hooks/useAuth";
import { currentPageState, isLoggedInState } from "../../storage/app";
import { useEffectOnce } from "../../hooks/useCustomEffects";

export function AuthProvider() {
  const isLoggedIn = useRecoilValue(isLoggedInState);
  const [currentPage, setCurrentPagePath] = useRecoilState(currentPageState);
  const navigate = useNavigate();
  const { initApp } = useAuth();
  const location = useLocation();

  useEffectOnce(() => {
    const path = `${location.pathname}${location.search}`;
    setCurrentPagePath((prev) => ({
      ...prev,
      path,
    }));
  });

  useEffect(() => {
    initApp();
  });

  useEffect(() => {
    if (!isLoggedIn) {
      navigate(LOGIN_PAGE.route, { replace: true });
    }
  }, [isLoggedIn]);

  return null;
}
